export enum OrderStatus {
  'received' = 'Received',
  'staging' = 'Staging',
  'selectedforpicking' = 'Picking',
  'shipped' = 'Shipped',
  'invoiced' = 'Invoiced',
}
